const state = {
  tags_list: []
}

const getters = {
  tagsCount: function(state) {
    return state.tags_list.length
  },
  tagsList: function(state) {
    return state.tags_list
  }
}

const mutations = {
  loadTags: function(state, tags) {
    state.tags_list = tags
  },
  addTag: function(state, tag) {
    state.tags_list.push(tag)
  },
  removeTag: function(state, tag) {
    state.tags_list.remove(tag)
  },
  resetTags: function(state) {
    state.tags_list = []
  }
}

const actions = {
  resetTags (context) {
    context.commit('resetTags', [])
  },
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/tag.js